import React, {Component} from 'react'
import {_getTotalProcesses} from "../../../../../../services/apis/WorkerServices"

class IAATotalProcesses extends Component {
    state = {
        total: 0
    }

    _refresh = null

    componentDidMount() {
        this._fetchTotal()
        this._refresh = setInterval(() => {
            this._fetchTotal()
        }, 5000)
    }

    componentWillUnmount() {
        this._refresh && clearInterval(this._refresh)
    }

    _fetchTotal = async () => {
        const {data, success} = await _getTotalProcesses()

        if (success) {
            this.setState({
                total: data
            })
        }
    }

    render() {
        return (
            <div className="IAATotalProcesses">
                <strong>Processes:</strong>
                <span className="Number"> {this.state.total} processes</span>
            </div>
        )
    }
}

export default IAATotalProcesses



// WEBPACK FOOTER //
// ./src/app/pages/dashboard/workers/components/iaa/IAATotalProcesses.js